'use strict';

import { MoreTexts } from '../moreText/moreText';

import ContentFilter from '../content-filter/content-filter';
import Rating from '../rating/rating';
import LikeContainer from '../like-container/like-container';
import ModalGallery from '../modal-gallery/modal-gallery';

export default class Tabodion {
	constructor() {
		this.root = document.querySelector('[data-tabodion]');
		if (!this.root) return false;
		this._matchHTML();
		this._handler();
	}

	_matchHTML() {

		this.btns = [...this.root.querySelectorAll('[data-tabodion-btn]')];
		this.contentContainers = [...this.root.querySelectorAll('[data-tabodion-content]')];
	}

	_openTab(btn, container, animationName) {
		let action = btn.dataset.tabAction;

		if (typeof action !== 'undefined') {
			if (!btn.classList.contains('is-loaded')) {
				btn.classList.add('is-loading');
			}
		}

		function _callback() {
			if (typeof action !== 'undefined') {
				if (!btn.classList.contains('is-loaded')) {
					$.ajax({
						type: 'GET',
						url: action,
						beforeSend: () => {
						},
						success: (data) => {
							btn.classList.remove('is-loading');
							container.querySelector('.tabodion__content-wrapper').innerHTML = data;
							btn.classList.add('is-loaded');
							this._initContentFilter();
							this._initRating();
							this._initLikes();
							this._initModalGallery();
							new MoreTexts({ root: 'data-more-text' });
						}
					});
				}
			}
		}

		if (typeof action !== 'undefined') {
			if (!btn.classList.contains('is-loaded')) {
				container.querySelector('.tabodion__content-wrapper').innerHTML = '';
			}
		}
		
		if (animationName === 'fadeIn') {
			$(container).fadeIn(350, _callback.bind(this));
		} else {
			$(container).slideDown(350, _callback.bind(this));
		}
	}

	_handler() {
		this.btns.forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();

				let activeTab = btn.dataset.tabodionBtn;


				if (btn.classList.contains('tabodion__accordion-heading')) {

					if (btn.classList.contains('is-active')) {
						btn.classList.remove('is-active');
						$(this.contentContainers).slideUp(350);
					} else {
						this.btns.forEach(btn => {
							btn.classList.remove('is-active');
							$(this.contentContainers).slideUp(350);
						});

						btn.classList.add('is-active');

						this.btns.forEach(btn => {
							if (btn.dataset.tabodionBtn === activeTab) {
								btn.classList.add('is-active');
							}
						});

						this.contentContainers.forEach(container => {
							if (container.dataset.tabodionContent === activeTab) {
								window.dispatchEvent(new Event('resize'));
								this._openTab(btn, container, 'slideDown');
							}
						})
					}


				} else {
					this.contentContainers.forEach(container => {
						container.style.display = 'none';
						if (container.dataset.tabodionContent === activeTab) {
							window.dispatchEvent(new Event('resize'));

							this._openTab(btn, container, 'fadeIn')
						}
					})

					this.btns.forEach(btn => {
						btn.classList.remove('is-active');
						if (btn.dataset.tabodionBtn === activeTab) {
							btn.classList.add('is-active');
						}
					})
				}

				// this.btns.forEach(btn => {
				// 	if (btn.dataset.tabodionBtn === activeTab) {
				// 		btn.classList.add('is-active');
				// 	}
				// })

			})
		})
	}

	_initContentFilter() {
		let filters = [...document.querySelectorAll('[data-content-filter]')];

		filters.forEach(filter => {
			let contentFilter = new ContentFilter({
				root: filter
			});

			contentFilter.init();
		});
	}

	_initRating() {
		let ratings = [...document.querySelectorAll('[data-rating]')];

		ratings.forEach(rating => {
			let ratingInit = new Rating({
				root: rating
			});

			ratingInit.init();
		});
	}

	_initLikes() {
		let likeContainers = [...document.querySelectorAll('[data-like-container]')];

		likeContainers.forEach(container => {
			let like = new LikeContainer({
				root: container
			});

			like.init();
		});
	}

	_initModalGallery() {
		const modalGallery = new ModalGallery();

		modalGallery.init();
	}
}
